
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAntenna2 as ObiAntenna2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-antenna-2.js';
 
 
 

 
 export const ObiAntenna2 = createComponent({
   react: React,
   tagName: 'obi-antenna-2',
   elementClass: ObiAntenna2Element,
   events: {
     
   }
  });
 
 